import { Pipe, PipeTransform } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Pipe({ name: 'warrantyStatus' })
export class WarrantyStatusPipe implements PipeTransform {

  constructor(
    private translateService: TranslateService,
    private fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  transform(status: string): string {
    switch (status) {
      case 'active':
        return this.translateService.instant('WARRANTY_STATUS.ACTIVE');
      case 'expired':
        return this.translateService.instant('WARRANTY_STATUS.EXPIRED');
      case 'extended':
        return this.translateService.instant('WARRANTY_STATUS.EXTENDED');
      case 'future':
        return this.translateService.instant('WARRANTY_STATUS.FUTURE');
      default:
        return null
    }
  }
}
